import { createAction } from "@reduxjs/toolkit";

export const applyFacetDraft = createAction("facets/applyFacetDraft");
